export interface AddMaterial{
    materialName:string,
    materialType:number,
    language:number,
    tags:string[],
    status:number
    materialFileId:number
}

export function AddMaterialDefaultValues():AddMaterial
{
    return{materialName:'',materialType:0,language:0,tags:[],status:1,materialFileId:0}
}

export interface ViewMaterial{
  id:string,
  materialId:string,
  materialName: string,
  materialType: string,
  materialTypeId:number
  language: string,
  languageId:number
  tags: string,
  status: string,
  statusId:number,
  materialFileName:string,
  materialFileId: number,
  replacementMaterialName: string,
  replacementMaterialFileName: string,
  replacementMaterialFileId: number,
  replacementMaterialId:string,
  isReplaced:boolean,
  isEditEnabled: boolean,
  isDeleteEnabled: boolean,



}

export function ViewMaterialDefaultValues():ViewMaterial{
    return{
        id: '',
        materialId:'',
        materialName: '',
        materialType: '',
        materialTypeId:0,
        language: '',
        languageId:0,
        tags: '',
        status: '',
        statusId:0,
        materialFileName:'',
        materialFileId: 0,
        replacementMaterialName:'',
        replacementMaterialFileName: '',
        replacementMaterialFileId: 0,
        replacementMaterialId:'',
        isReplaced:false,
        isEditEnabled: true,
        isDeleteEnabled: true
    }
}

export interface UpdateMaterial{
    id:string,
    materialName:string,
    materialType:number,
    isMaterialTypeEditable:boolean
    language:number,
    isLanguageEditable:boolean,
    tags:string[],
    status:number,
    materialFileId:number,
    materialFileName:string,
    isReplaced:boolean,
    replacementMaterialId:string,
    showFileUploader:boolean

}

export function UpdateMaterialDefaultValues():UpdateMaterial
{
    return{
        id:'',
        materialName: '',
        materialType: 0,
        isMaterialTypeEditable:false,
        language: 0,
        isLanguageEditable:false,
        tags: [],
        status: 0,
        materialFileId: 0,
        materialFileName:'',
        isReplaced: false,
        replacementMaterialId: '',
        showFileUploader:false

    }
}

export interface MaterialDownloadAuditLog {
  courseId: string,
  materialId: string
}

export function MaterialDownloadAuditLogDefaultValues(): MaterialDownloadAuditLog
{
    return{
        courseId: '',
        materialId: '',
    }
}

export interface CheckDraftMaterialForPublishedCourse
{
    materials:any[]
}

export function CheckDraftMaterialForPublishedCourseDefaultValues():CheckDraftMaterialForPublishedCourse
{
    return{materials:[]}
}
